import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class DonationSummary extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.showColumn = this.showColumn.bind(this);
		this.getColumns = this.getColumns.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			health_facilities_id:"all",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			lab_sections_id:["all"],
			lab_sections:[],

			start_date 	: "",
			end_date 	: "",
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			convoke_places_id:"all",

			table_list:[],
			listado:[],

			change_check: false,

			//test datatable to export
			columns:[],
			columns_default:[],
			filename:"",
			search_by:"donations",
			fraction_columns:"",
			search_type:"date",

			selectedOption:null,
			options: [],

			extraction_type_name:"",
			convoke_places_name:"",
			lab_section_name:"",
			date_hour:"",
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			//health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		var path = this.props.match.path.replace('/', '');

		switch(path){
			case 'donation_summary':
				this.setState({
					filename: "Resumen de Donaciones"
				});
				break;
		}

	}

	componentDidMount(){
		
		this.$select = $(this.select);
		this.$select.chosen();
		this.$select.on('change', this.handleChange);

		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		
		this.getColumns('inicial');

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getConvokePlace();

		fetch(Config.default.apiGateway.URL+'donation_type_extraction', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					extraction_type: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		})

		this.getLabSection();

	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getColumns(start){
		fetch(Config.default.apiGateway.URL+'list_show?option=groupByList&menu=donors_report',{
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({columns:[]});

				response.map((res)=>{
					if(res.list_name === 'RESUMEN DONACIONES'){
						res.columns.map((col, i)=>{
							if(col.active){
								if(i === 0){
									if(col.column_name !== 'HEMATOCRIO' && col.column_name !== 'HEMOGLOBINA' &&
										col.column_name !== 'PACIENTE' && col.column_name !== 'FECHA REGISTRO'){
										this.setState({
											columns: [...this.state.columns, {
												title: col.column_name === 'NÚMERO DONACIÓN' ? 'No. DONACIÓN' : col.column_name, 
												width: "200px",
												visible: 'block'
											}]
										});
									}
								}else{
									if(col.column_name !== 'HEMATOCRIO' && col.column_name !== 'HEMOGLOBINA' &&
										col.column_name !== 'PACIENTE' && col.column_name !== 'FECHA REGISTRO'){
										this.setState({
											columns: [...this.state.columns, {
												title: col.column_name === 'NÚMERO DONACIÓN' ? 'No. DONACIÓN' : col.column_name,
												width: "200px",
												visible: 'block'
											}]
										});
									}
										
								}
								
							}
						})
					}
						
				});

				if(start === 'inicial'){
					setTimeout(()=>{
						this.setTable();
					}, 500);
				}	
			}
		});
	}

	setTable(){
		var fechas = 
			"Información Del: "+moment(this.state.start_date).format("DD/MM/YYYY")+ 
			" Al: "+moment(this.state.end_date).format("DD/MM/YYYY") 
		var header = '';
	

		header += '<thead>';

		var index = this.state.columns.findIndex(obj => obj.title === 'Fraccionamiento');

		if(index !== -1){
			header += 	'<tr>';

			this.state.columns.map((col)=>{
				if(col.title !== 'Fraccionamiento'){
					header += '<th style="font-size:11px; width:'+col.width+' !important;" rowspan="2">'+col.title+'</th>'					
					
				}else if(col.width !== undefined){
					header += '<th style="font-size:11px;width:'+col.width+' !important;" rowspan="2">'+col.title+'</th>'
					
				}else if(col.title === 'Fraccionamiento'){
					header += '<th style="font-size:11px; width:290px !important;" colspan="'+this.state.fraction_columns+'">'+col.title+'</th>'
				}
			})

			header += 	'</tr>';

			header += 	'<tr>';
			this.state.columns.map((col)=>{
				if(col.title === 'Fraccionamiento'){
					for(var i = 0; i < this.state.fraction_columns; i++){
						console.log('no debe entrar')
						header += (i === 0 ? '<th style="width:30px !important"></th>' : '<th></th>')

					}	
				}
			})
			header += 	'</tr>';

		}else{
			header += 	'<tr>';
			this.state.columns.map((col)=>{
				if(col.width !== undefined){
					header += '<th style="font-size:11px;width:'+col.width+' !important;">'+col.title+'</th>'

				}else {
					header += '<th style="font-size:11px;width:'+col.width+' !important;">'+col.title+'</th>'
				
				}
			
					
			})
			header += 	'</tr>';

		}
			
		header += '</thead>';
		
		this.$el = $(this.el);
		this.$el.append(header);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation: 'landscape',
                	pageSize: 'A3',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});

                		var num = 2
						if(this.state.search_type === 'date'){
							doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] })
							num = 3
						}

						doc.content.splice(num, 0, {
							columns:[
								this.state.convoke_places_id !== "all" ?
									{text: 'Lugar de Colecta', width:'12%', fontSize:7}
								: {text:"", width:0},
								this.state.convoke_places_id !== "all" ?
									{text: this.state.convoke_places_name, bold:1, margin:[0,0,0,10], fontSize:7 }
								: {text:"", width:0},

								this.state.extraction_type_id !== "all" ?
									{text: 'Extracción', width:'8%', fontSize:7}
								: {text:"", width:0},
								this.state.extraction_type_id !== "all" ?
									{text: this.state.extraction_type_name, bold:1, margin:[0,0,0,10], fontSize:7}
								: {text:"", width:0},

								this.state.lab_section_name !== "" ?
									{text: 'Seccion Laboratorio', width:'8%', fontSize:7}
								: {text:"", width:0},
								this.state.lab_section_name !== "all" ?
									{text: this.state.lab_section_name, bold:1, margin:[0,0,0,10], fontSize:7}
								: {text:"", width:0},

							]
						});


                		
            			doc.content[5] = {
            				columns:[

								{width:'70%', text: ''},
								{
									width:'30%',
									text:'Número de Unidades : '+(
												this.state.table_list.res !== undefined ?
													' '+this.state.table_list.Count
												: 0),
									fontSize:7,
									bold:true,
									margin:[0,10,0,10]
								}
							]
            			}
                		
                		doc.styles.tableHeader.fontSize = 6;
                		doc.defaultStyle.fontSize = 6; 
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	}
            	],
			data: this.state.listado,
			//columns:this.state.columns,
			order: [[ 2, "asc" ]],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			info:false,
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,

		});

		if($('.fract')[0] !== undefined){
			$('.fract thead tr').each(function(i){
				if(i === 1){
					$(this).children('th').each(function(j){
						if(j===0){
							
							$(this).removeAttr('style');
							$(this).attr('style',  'width:10px !important');
							
						}
					})
				}
			})
		}
		

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		if(e.target.name === 'lab_sections_id'){
			var options = e.target.options;
			var value = [];
			var name = "";
			for (var i = 0, l = options.length; i < l; i++) {
			    if (options[i].selected) {
			    	if(options[i].value === 'all'){
			    		value = [];
			    		value.push(options[i].value);
			    		
			    		break;
			    	}else{
			    		value.push(parseInt(options[i].value));
			    		name += options[i].text + ', '
			    	}
			      
			    }
			}

			this.setState({
    			lab_sections_id: value,
    			lab_section_name:name.substring(0,name.length-2)
    		})
			setTimeout(()=>{
				this.$select.val(value).trigger("chosen:updated");
			}, 300)

		}else if(e.target.name === 'convoke_places_id'){
			this.setState({
				convoke_places_name: e.target.options[e.target.selectedIndex].text,
				[e.target.name]: e.target.value
			})

		}else if(e.target.name === 'extraction_type_id'){
			this.setState({
				extraction_type_name: e.target.options[e.target.selectedIndex].text,
				[e.target.name]: e.target.value
			})


		}else{
			this.setState({
				[e.target.name]: e.target.value
			});
		}
			
		
		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			setTimeout(()=>{
				this.getConvokePlace();
				this.getLabSection();
			}, 500);
				
		}else if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.getColumns();

				this.props.waiting.handleShow('Buscando...');

				var sections = [];
				this.state.lab_sections.map((l)=>{
					if(this.state.lab_sections_id[0] === 'all'){
						sections.push(l.id);
					}
				})


				var obj = {
					convoke_places_id: this.state.convoke_places_id,
					start_date: this.state.start_date,
					end_date: this.state.end_date,
					start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					extraction_type_id: this.state.extraction_type_id,
					section_ids: this.state.lab_sections_id[0] === 'all' ? sections : this.state.lab_sections_id,
					search_by: this.state.search_by,
					health_facilities_id:this.state.health_facilities_id
				}
				
				fetch(Config.default.apiGateway.URL+'reports/donations_number',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							table_list: response,
							listado: [],
							fraction_columns: response.fraction_columns
						});

						var list = [];
						response.res.map((r)=>{
							var obj = [];
							var donor = this.state.columns.findIndex(obj => obj.visible === 'block' && obj.title === 'DONADOR');
							if(donor !== -1){
								obj.push(r.person_donor.lastname1+' '+r.person_donor.lastname2+' '+r.person_donor.names);
							}

							var f_ext = this.state.columns.findIndex(obj => obj.visible === 'block' && obj.title === 'FECHA EXTRACCIÓN');
							if(f_ext !== -1){
								obj.push(r.donation.timestamp_date !== null ?
									moment(r.donation.timestamp_date).format('DD/MM/YYYY')+' '+
									(r.donation.timestamp_hour !== null ?
										moment(r.donation.timestamp_hour, 'HH:mm:ss').format('HH:mm')
									: null)
								: null);
							}

							var num = this.state.columns.findIndex(obj => obj.visible === 'block' && (obj.title === 'NÚMERO DONACIÓN' || obj.title === 'No. DONACIÓN'));
							if(num !== -1){
								obj.push(r.donation.donation_number);
							}
							
							var sex = this.state.columns.findIndex(obj => obj.visible === 'block' && obj.title === 'SEXO');
							if(sex !== -1){
								obj.push(r.person_donor.sex === 'HOMBRE' ? 'M' : 'F');
							}
							
							var don = this.state.columns.findIndex(obj => obj.visible === 'block' && obj.title === 'TIPO DONACIÓN');
							if(don !== -1){
								obj.push(r.donation_type);
							}
							var ext = this.state.columns.findIndex(obj => obj.visible === 'block' && obj.title === 'TIPO EXTRACCIÓN');
							if(ext !== -1){
								obj.push(r.extraction_type);
							}
						
							if(r.fraction_units.length === 0){
								for(var j = 0; j< response.fraction_columns; j++){
									obj.push('');
								}
							}else if(r.fraction_units.length === response.fraction_columns){
								r.fraction_units.map((f, j)=>{
									obj.push(f);
								});
							}else if(r.fraction_units.length < response.fraction_columns){
								r.fraction_units.map((f, j)=>{
									obj.push(f);
								});

								for(var j = r.fraction_units.length; j< response.fraction_columns; j++){
									obj.push('');
								}
							}

							response.dynamic_columns.map((col, i)=>{
								if(r.dynamic_columns !== null){
									var index = r.dynamic_columns.findIndex(obj => obj.analitical_test_id === col.id);

									if(index !== -1){
										obj.push(r.dynamic_columns[index].value === 'POSITIVO' ?
															'POS'
														: r.dynamic_columns[index].value === 'NEGATIVO' ?
															'NEG'
														: r.dynamic_columns[index].value)
									}else{
										obj.push('');
									}
								}else{
									obj.push('');
								}
							})

							list.push(obj);
						});

						this.setState({
							listado: list
						});

						var cols = this.state.columns;

						if(response.fraction_columns){
							cols.push({
								title: 'Fraccionamiento',
								target:response.fraction_columns,
								visible:'block'
							});
						}

						response.dynamic_columns.map((d)=>{
							cols.push({title:d.code, visible:'block'});
						});

						this.setState({
							columns: cols
						});


						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
					
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}	
		}
				

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id:'all'// sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	showColumn(column_name){
    	var i =0;
      	for(i =0; i < this.state.columns.length;i++){
        	if(this.state.columns[i].column_key === column_name && this.state.columns[i].active){
          		return false;
        	}
      	} 
    	
    	return true;
 	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	getLabSection(){
 		fetch(Config.default.apiGateway.URL+'lab_sections/by_health_facility?id='+this.state.health_facilities_id, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

				this.setState({
					lab_sections: response
				});

				this.$select.trigger("chosen:updated");
			}
		});
 	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					{t('sidebar.nav.reports.donation_summary')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_rep_summary_donation"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>
					
					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Centro</span>
									<select type="text" name="health_facilities_id" id="health_facilities_id" 
										value={this.state.health_facilities_id} disabled={!this.state.change_check} onChange={this.handleChange}
										className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((h, i)=>{
											return <option key={i} value={h.id}>
												{h.name}
											</option>
										})}
									</select>

									<input type="checkbox" name="change_center" id="change_center" 
										style={{marginRight:"5px"}} onChange={this.checking}
										checked={this.state.change_check} />
									<span className="span-min">Cambiar</span>
								</div>
								<div className="form-group">
									<span className="span-min">Lugar de Colecta</span>
									<select className="form-control" name="convoke_places_id" id="convoke_places_id"
										value={this.state.convoke_places_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.convoke_places.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Busqueda</span>
									<select className="form-control" name="search_type" id="search_type"
										value={this.state.search_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="date">Fecha</option>
										<option value="folio">Folio</option>
									</select>
								</div>
								{this.state.search_type === 'date' ?
									<div className="form-group">
										<span className="span-min">Buscar Por</span>
										<select className="form-control" name="search_by" id="search_by"
											value={this.state.search_by} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="donations">Fecha Donación</option>
											<option value="results">Fecha Resultados</option>
										</select>
									</div>
								: null}
								{this.state.search_type === 'date' ?
									<div>
										<div className="form-group">
											<span className="span-min">Fecha Desde</span>
											<input type="date" className="form-control hour-input" name="start_date" id="start_date"
												value={this.state.start_date} onChange={this.handleChange} required />
										</div>
										<div className="form-group">
											<span className="span-min">Fecha Hasta</span>
											<input type="date" className="form-control hour-input" name="end_date" id="end_date"
												value={this.state.end_date} onChange={this.handleChange} required />
										</div>
									</div>
								: <div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Folio Desde</span>
										<input type="text" className="form-control"  name="start_folio" id="start_folio"
											value={this.state.start_folio} onChange={this.handleChange} />
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">Folio Hasta</span>
										<input type="text" className="form-control" name="end_folio" id="end_folio"
											value={this.state.end_folio} onChange={this.handleChange} />
									</div>
								</div>
								}
									
								<div className="form-group">
									<span className="span-min">Tipo de Extracción</span>
									<select className="form-control" name="extraction_type_id" id="extraction_type_id"
										value={this.state.extraction_type_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.extraction_type.map((don, i)=>{
											return <option key={i} value={don.donation_type_extraction.id}>
												{don.lookup_value}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Sección Laboratorio</span>
									<select className="form-control"  name="lab_sections_id" id="lab_sections_id"
										value={this.state.lab_sections_id} 
										multiple={true} required data-placeholder={'Seleccione...'}
										ref={el => this.select = el}>
										<option value="all">TODOS</option>
										{this.state.lab_sections.map((l, i)=>{
											return <option key={i} value={l.id}>
												{l.name}
											</option>
										})}
									</select>
									
								</div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
									<span>
										{t('sidebar.nav.reports.donation_summary')}
									</span>
								</div>
								{this.state.search_type === 'date' ?
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								:null}
								<div className="col-xs-12">
									<div className="col-xs-12">
										{this.state.convoke_places_id !== 'all' && this.state.convoke_places_id !== "" ?
											<span>
												Lugar de Colecta:   
												<b style={{marginLeft:"5px"}}>{this.state.convoke_places_name}</b>
											</span>	
										:null}

										{this.state.extraction_type_id !== 'all' && this.state.extraction_type_id !== "" ?
											<span style={{marginLeft:"15px"}}>
												Extracción: 
												<b style={{marginLeft:"5px"}}>{this.state.extraction_type_name}</b>
											</span>
										:null}

										{this.state.lab_sections_id[0] !== 'all' && this.state.lab_sections_id[0] !== "" && this.state.lab_section_name !== "" ?
											<span style={{marginLeft:"15px"}}>
												Secciones Laboratorio: 
												<b style={{marginLeft:"5px"}}>{this.state.lab_section_name}</b>
											</span>
										:null}
									</div>
								</div>
								

								<div className="col-xs-12" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={this.state.columns.length > 7 ? "fract" : "table"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>

								</div>
								<div className="col-xs-12">
									<span>
										Número de Unidades: 
										{this.state.table_list.res !== undefined ?
											' '+this.state.table_list.Count
										: 0}
									</span>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (DonationSummary);